export enum SCREEN {
    ORGANISATIONS,
    ORGANISATION_HOME,
    PROJECT_HOME,
    MODEL,
    SYS_ADMIN,
    USERS,
    INSIGHTS,
    BILLING_ADMIN,
    ORGANISATION_BILLING,
    ONBOARDING_MODEL,
    MODEL_INTRODUCTION,
    ANALYSIS,
    HELP
}